<template>
<div id="kt_header" class="kt-header kt-grid__item  kt-header--fixed " data-ktheader-minimize="on">
    <div class="kt-container">
        <div v-if="admin_hashid !== null">
            <button
                    class="mt-3 btn btn-primary" size="sm"  type="button"
                    id="back_to_admin_panel" @click="backToAdminPanel"
            >
                {{ $t('btn.backToAdminPanel') }}
            </button>
        </div>

        <!-- begin:: Brand -->
        <div class="kt-header__brand " id="kt_header_brand">
            <div class="kt-header__brand-logo">
                <router-link v-if="setting('header-logo')" to="/">
                    <img alt="Logo" v-bind:src="setting('header-logo')" />
                </router-link>
            </div>
        </div>
        <!-- end:: Brand -->

        <!-- begin:: Header Topbar -->
        <div class="kt-header__topbar">

            <!--begin: Notifications -->
            <!-- @include('dashboard::vendors.partials.notification') -->

            <!--end: Notifications -->

            <!--begin: Quick actions -->
            <!-- @include('dashboard::vendors.partials.quick-actions') -->

            <!--end: Quick actions -->

            <!--begin: User bar -->
            <dashboard-header-theme-toggle></dashboard-header-theme-toggle>
            <dashboard-header-newsletter-bar v-if="!$can('manage')"></dashboard-header-newsletter-bar>
            <dashboard-header-user-bar></dashboard-header-user-bar>

            <!--end: User bar -->
        </div>

        <!-- end:: Header Topbar -->
    </div>
</div>
</template>

<script>
import {userBar,newsBar,themeToggle} from './header/index'
import {mapGetters} from "vuex";

export default {
    components: {
        'dashboard-header-user-bar': userBar,
        "dashboard-header-newsletter-bar": newsBar,
        'dashboard-header-theme-toggle': themeToggle,
    },
    data() {
        return {
            admin_hashid: null
        }
    },
    computed: {
        ...mapGetters('auth', [
            'user'
        ])
    },
    methods: {
        setting (slug) {
            return null;
        },
        backToAdminPanel() {
            let admin_token = window.localStorage.getItem('Admin_token');

            let param = {
                token: admin_token,
                hashid: this.user.admin_id,
            };

            this.$store.dispatch('auth/backToAdminPanel', param)
                .then(
                    response => {
                        window.localStorage.removeItem('Admin_token');
                        window.location.replace(this.$url(''));
                    }
                )
        },
    },
    mounted() {
        if (this.user.admin_id) {
            this.admin_hashid = this.user.admin_id
        }
    }
}
</script>

<style>

</style>